import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Idle} from "@ng-idle/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";


@Component({
	selector: "app-session-modal",
	standalone: true,
	providers:[Idle],
	template: `
        <div class="modal-header">
			<span class="modal-title">Idle Warning</span>
		</div>
        <div class="modal-body">
            <p>
                You're idle
            </p>
            <div class="badge bg-warning text-black p-3 w-100">Timeout in: {{ countdown }}</div>
        </div>
        <div class="modal-footer">
			<button class="btn btn-primary w-100" (click)="here()">I'm here!</button>
		</div>
	`
})
export class AppSessionModal implements OnInit{
	
	@Input()
	countdown!:number;
	
	@Output()
	onUserHere:EventEmitter<void> = new EventEmitter();
	
	
	constructor(private modal:NgbActiveModal) {}
	
	ngOnInit(): void {
		
    }
	
	
	here(){
		this.onUserHere.emit();
	}
	
	
	public close(){
		this.modal.close();
	}
}
